<template>
  <div id="app">
    <v-app id="inspire">
      <v-form ref="form" v-model="valid" :lazy-validation="lazy">
        <v-card v-model="show" color="#FFFF99">
          <v-card-title>
            <v-icon large left>mdi-excavator</v-icon>
            Posventa - Equipos
          </v-card-title>
          <v-card-text class="pt-2">
            <v-row dense>
              <v-col cols="12" sm="6" md="6">
                <v-select v-model="select" :items="equipo" item-text="nombre" item-value="nombre" label="Equipo"
                  return-object single-line menu-props="auto" hide-details required dense></v-select>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
        <v-card>
          <input type="file" id="archivoExcel" @change="subirExcel" />
          <v-data-table :headers="headers" :items="detalle" locale="es-ar" class="elevation-1" :items-per-page="40"
            :footer-props="{
        itemsPerPageText: 'Items por página',
      }" :loading="loadtable" loading-text="Cargando... Espere por favor"
            no-data-text="No hay datos disponibles">
            <template v-slot:top>
              <v-toolbar flat>
                <v-toolbar-title>Completar Item</v-toolbar-title>
                <v-divider class="mx-4" inset vertical></v-divider>
                <v-spacer></v-spacer>
                <v-dialog v-model="dialog" max-width="850px">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn color="primary" dark class="mb-2" v-bind="attrs" v-on="on">
                      Agregar Item
                    </v-btn>
                  </template>
                  <v-card>
                    <v-card-title>
                      <span class="headline">{{ formTitle }}</span>
                    </v-card-title>

                    <v-card-text>
                      <v-container>
                        <v-row dense>
                          <v-col cols="12" sm="3" md="3">
                            <v-text-field autofocus v-model="editedItem.item" label="Item"></v-text-field>
                          </v-col>
                          <v-col cols="12" sm="6" md="6">
                            <v-text-field v-model="editedItem.tipo" label="Tipo"></v-text-field>
                          </v-col>
                          <v-col cols="6" sm="3" md="3">
                            <v-text-field v-model="editedItem.codigo" label="Código"></v-text-field>
                          </v-col>
                          <v-row dense>
                            <v-col cols="6" sm="6" md="6">
                              <v-text-field v-model="editedItem.descr" label="Descripción"></v-text-field>
                            </v-col>
                            <v-col cols="6" sm="2" md="2">
                              <v-text-field v-model="editedItem.unidad" label="Unidad"></v-text-field>
                            </v-col>

                            <v-col cols="6" sm="2" md="2">
                              <v-text-field v-model="editedItem.costo" label="Costo"></v-text-field>
                            </v-col>
                            <v-col cols="6" sm="2" md="2">
                              <v-select v-model="editedItem.moneda" :items="moneda" item-text="nombre"
                                item-value="valor" label="Moneda">
                              </v-select>
                            </v-col>
                          </v-row>
                        </v-row>
                      </v-container>
                    </v-card-text>

                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn color="blue darken-1" text @click="close">
                        Cancelar
                      </v-btn>
                      <v-btn color="blue darken-1" text @click="save">
                        Guardar
                      </v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
                <v-dialog v-model="dialogDelete" max-width="500px">
                  <v-card>
                    <v-card-title class="headline">Está seguro que desea borrar?</v-card-title>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn color="blue darken-1" text @click="closeDelete">Cancel</v-btn>
                      <v-btn color="blue darken-1" text @click="deleteItemConfirm">OK</v-btn>
                      <v-spacer></v-spacer>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </v-toolbar>
            </template>
            <template v-slot:item.actions="{ item }">
              <v-icon small class="mr-2" color="purple" @click="editItem(item)">
                mdi-pencil
              </v-icon>
              <v-icon small color="red" @click="deleteItem(item)">
                mdi-delete
              </v-icon>
            </template>
          </v-data-table>
        </v-card>

        <v-card color="blue" dark tile>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="success" @click.stop="guardaritems()">Guardar</v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-app>
  </div>
</template>

<script>
import moment from "moment";
import axios from "../../../axios-auth";
import readXlsFile from "read-excel-file";
export default {
  data: (vm) => ({
    usuario: "",
    valid: false,
    lazy: false,
    requiredRules: [(v) => !!v || "Dato obligatorio"],
    numberRule: [
      (v) => v.length > 1 || "2 digitos",
      (v) => v <= 31 || "El valor debe ser menor a 31",
    ],
    select: "",
    moneda: [
      { nombre: "Dólar", valor: "D" },
      { nombre: "Pesos", valor: "P" },
    ],
    // equipos: [],
    equipo: [
      { nombre: "Noja Power - Reconectador" },
      { nombre: "Toshiba - Regulador" },
    ],
    // item: [],
    // items: [],
    // itemtarea: "",
    dialog: false,
    dialogDelete: false,
    loadtable: false,
    headers: [
      { text: "Item", value: "item", sortable: false },
      { text: "Tipo", value: "tipo", sortable: false },
      { text: "Código", value: "codigo", sortable: false },
      { text: "Descripción", value: "descr", sortable: false },
      { text: "Unidad", value: "unidad", sortable: false },
      { text: "Costo", value: "costo", sortable: false },
      { text: "Moneda", value: "moneda", sortable: false },
      { text: "Acciones", value: "actions", sortable: false },
    ],
    cabecera: [
      { text: "Item", value: "item" },
      { text: "Tipo", value: "tipo" },
      { text: "Código", value: "codigo" },
      { text: "Descripción", value: "descr" },
      { text: "Unidad", value: "unidad" },
      { text: "Costo", value: "costo" },
      { text: "Moneda", value: "moneda" },
    ],
    editedIndex: -1,
    editedItem: {
      item: "",
      tipo: "",
      codigo: "",
      descr: "",
      unidad: "",
      costo: "",
      moneda: "",
    },
    defaultItem: {
      item: "",
      tipo: "",
      codigo: "",
      descr: "",
      unidad: "",
      costo: "",
      moneda: "",
    },
    detalle: [],
    items: [],
  }),
  watch: {
    select: function (val) {
      //this.equipo = this.select.nombre;
      this.asignarvalor();
    },
    dialog(val) {
      val || this.close();
      console.log(this.valid);
    },
    dialogDelete(val) {
      val || this.closeDelete();
    },
  },
  computed: {
    formTitle() {
      return this.editedIndex === -1 ? "Nuevo Horario" : "Editar Horario";
    },
    show: {
      get() {
        //this.mostrar = true;
        //this.resptrabajo = this.$store.state.nombre.toString().trim();
        //this.cargarObras();
        // return this.visible;
      },
      set(value) {
        if (!value) {
          this.vaciarListado();
          this.$refs.form.resetValidation();
          document.getElementsByClassName("v-dialog--active")[0].scrollTop = 0;
          this.$emit("close");
        }
      },
    },
  },
  methods: {
    subirExcel() {
      // const schema = {
      //   "0": {
      //     prop: "tarea",
      //     type: String,
      //   },
      //   "1": {
      //     prop: "fechainicio",
      //     type: String,
      //   },
      //   "2": {
      //     prop: "fechafin",
      //     type: String,
      //   },
      // };
      const map = {
        item: "item",
        tipo: "tipo",
        codigo: "codigo",
        descr: "descr",
        unidad: "unidad",
        costo: "costo",
        moneda: "moneda",
      };

      const input = document.getElementById("archivoExcel");
      readXlsFile(input.files[0], { map }).then(({ rows, errors }) => {
        //this.cronograma = rows;
        rows.forEach((element) => {
          this.detalle.push(element);
        });
        //  console.log("ROW");
      });
    },

    asignarvalor() {
      console.log("PASO POR ACA");
      this.vaciarListado();
      this.loadtable = true;
      const nombre = this.select.nombre;
      let self = this;
      axios
        .get("/App/CargarDetalleComputo?", {
          params: {
            equipo: nombre,
          },
        })
        .then((response) => {
          //self.cronograma = response.data;
          response.data.forEach((element) => {
            self.detalle.push(element);
          });
          self.loadtable = false;
        })
        .catch((error) => {
          self.detalle = [];
          console.log(error);
        });
    },

    editItem(item) {
      this.editedIndex = this.detalle.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },

    deleteItem(item) {
      this.editedIndex = this.detalle.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialogDelete = true;
    },

    deleteItemConfirm() {
      this.detalle.splice(this.editedIndex, 1);
      this.closeDelete();
    },

    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },

    closeDelete() {
      this.dialogDelete = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },

    save() {
      if (this.editedIndex > -1) {
        Object.assign(this.detalle[this.editedIndex], this.editedItem);
      } else {
        this.detalle.push(this.editedItem);
      }
      this.close();
    },

    vaciarListado() {
      this.detalle = [];
      this.detallecomp = [];
    },

    guardaritems() {
      this.$swal({
        title: "Guardar Items",
        text: "¿Desea guardar los datos?",
        icon: "success",
        type: "success",
        showCancelButton: true,
        background: "#ececec",
        confirmButtonText: "Si",
        cancelButtonText: "No",
        showCloseButton: true,
        showLoaderOnConfirm: true,
      }).then((result) => {
        if (result.value) {
          this.detalle.forEach((element) => {
            if (element.descr != "" && element.descr != null) {
              //   const fill = (number, len) =>
              //     "0".repeat(len - number.toString().length) + number.toString();
              //   this.itemtarea = fill(Number(this.item) + 1, 3);
              this.items.push({
                item: element.item,
                tipo: element.tipo,
                descr: element.descr,
                codigo: element.codigo,
                unidad: element.unidad,
                costo: element.costo,
                moneda: element.moneda,
                equipo: this.select.nombre,
              });
            }
          });
          //   var detallecomp = {

          //     detalle: this.items,
          //   };

          let self = this;
          axios
            .post("/App/Guardardetallecomputo", this.items)
            .then((response) => {
              self.$refs.form.resetValidation();
              self.vaciarListado();
              self.showAlert({
                icon: "success",
                title: "Items guardados con éxito",
                vm: self,
              });
              self.$emit("close");
            })
            .catch({});
        } else {
        }
      });
    },
    showAlert(alertInfo) {
      alertInfo.vm.$swal.fire({
        icon: alertInfo.icon,
        title: alertInfo.title,
        showConfirmButton: false,
        background: "#ececec",
        timer: 3000,
      });
    },
  },
};
</script>
